import { b as y } from "./collabUri-Do8HqBaW.js";
let m = null;
const l = /* @__PURE__ */ new Set();
function g(s) {
  m = s, l.forEach((t) => t());
}
function I() {
  return m;
}
function T(s) {
  return l.add(s), () => l.delete(s);
}
function k(s, t = {}) {
  const r = t.search?.trim().toLowerCase() ?? "", e = t.email?.trim().toLowerCase() ?? "", a = s.filter((i) => !(t.kind && i.kind !== t.kind || t.typeId && i.page.typeId !== t.typeId || e && i.email?.toLowerCase() !== e || r && ![i.plainText, i.by, i.over, i.page.title].filter(Boolean).join(`
`).toLowerCase().includes(r))).map((i, o) => ({ record: i, index: o })).sort((i, o) => {
    const d = (o.record.on ?? "").localeCompare(i.record.on ?? "");
    return d !== 0 ? d : i.index - o.index;
  }).map(({ record: i }) => i);
  return t.limit !== void 0 && t.limit >= 0 ? a.slice(0, t.limit) : a;
}
const c = "tracker-content/", u = "type-page:";
function P(s, t) {
  const r = [];
  for (const e of s) {
    const n = e.documentId.startsWith(c);
    if (n && (!e.typedPage || e.typedPage.itemId !== e.documentId.slice(c.length))) continue;
    const a = e.documentId.startsWith(u) ? e.documentId.slice(u.length) : null, i = {
      kind: n ? "typed-page" : a ? "type-page" : "page",
      scope: "team",
      id: n ? e.typedPage.itemId : e.documentId,
      title: e.title ?? a ?? "Untitled",
      uri: n ? `tracker://${e.typedPage.itemId}` : y(t.orgId, e.documentId),
      typeId: n ? e.typedPage.typeId : a,
      issueKey: n ? e.typedPage.issueKey : null
    };
    r.push({
      id: `${i.uri}#${e.offset}`,
      kind: e.kind,
      text: e.text,
      plainText: e.plainText,
      by: e.by,
      email: e.email,
      on: e.on,
      over: e.over,
      line: e.line,
      page: i
    });
  }
  return r;
}
const p = 2e3, f = 3e4;
class R {
  listeners = /* @__PURE__ */ new Set();
  retryTimer = null;
  retryDelay = 0;
  subscribe(t) {
    return this.listeners.add(t), () => {
      this.listeners.delete(t), this.listeners.size === 0 && this.stopRetry();
    };
  }
  notify() {
    for (const t of [...this.listeners]) t();
  }
  /** After a load: whether the team index answered completely. */
  settled(t) {
    if (t) {
      this.stopRetry(), this.retryDelay = 0;
      return;
    }
    this.retryTimer || this.listeners.size === 0 || (this.retryDelay = this.retryDelay ? Math.min(this.retryDelay * 2, f) : p, this.retryTimer = setTimeout(() => {
      this.retryTimer = null, this.notify();
    }, this.retryDelay));
  }
  stopRetry() {
    this.retryTimer && clearTimeout(this.retryTimer), this.retryTimer = null;
  }
}
function M(s, t) {
  const r = new Set(s.map((e) => e.id));
  return [...s, ...t.filter((e) => !r.has(e.id))];
}
export {
  R as P,
  k as f,
  I as g,
  M as m,
  T as o,
  P as p,
  g as s
};
//# sourceMappingURL=pageMarks-B3ErYAff.js.map
